import * as React from "react";

import {noTrans} from "@atg-shared/no-trans";
import {ChatUtils} from "@atg-tillsammans-shared/chat-utils";
import {Link, type LinkBaseProps} from "@atg-ui/design-system";

import {Typography} from "../Typography";

import type {TypographyProps} from "../Typography";

export interface PreservedTextProps extends TypographyProps {
    children: string;
    slots?: {
        link: Omit<LinkBaseProps, "children" | "href">;
    };
}

const PreservedText = React.forwardRef<HTMLParagraphElement, PreservedTextProps>(
    (
        {
            variant = "body.md",
            color = "default",
            whiteSpace = "pre-wrap",
            as = "p",
            children,
            testId = "preserved-text",
            slots,
            ...rest
        },
        ref,
    ) => {
        const {
            target = "_blank",
            rel = noTrans("noopener noreferrer"),
            ...linkProps
        } = slots?.link || {};
        return (
            <Typography
                ref={ref}
                variant={variant}
                color={color}
                whiteSpace={whiteSpace}
                as={as}
                testId={testId}
                {...rest}
            >
                {children &&
                    ChatUtils.renderMessageTextWithLinks(children, (url, index) => (
                        <Link
                            key={`preserved-text-link-${index}`}
                            href={url.href}
                            target={target}
                            rel={rel}
                            data-test-id={`${testId}-link`}
                            {...linkProps}
                        >
                            {url.toString()}
                        </Link>
                    ))}
            </Typography>
        );
    },
);

PreservedText.displayName = noTrans("PreservedText");

export {PreservedText};
